module.exports = "<router-outlet></router-outlet>\n<loader></loader>\n"